import React, { useRef } from 'react';
import { Box, Button, Typography, Breadcrumbs, IconButton } from '@mui/material';
import { styled, keyframes } from '@mui/system';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { useContext } from 'react';
import { PageContext } from '../../pages/job-details';
import { config } from '../../config';


// Keyframe animation for the arrow
const bounce = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(10px);
  }
`;

// Styled component for the hero section
const HeroContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  position: 'relative',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100vw',   // Full width
  height: '70vh',  // Full height
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  textAlign: 'center',
  color: '#fff',
  [theme.breakpoints.down('sm')]: {
    height: '60vh',
  }
}));

const Overlay = styled(Box)({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: "black",
  opacity: .7,
  zIndex: 1, // Ensure it covers the background but is below the text
});

// Styled component for the arrow icon
const AnimatedIconButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  bottom: '100px', // Default position
  zIndex: 2,
  color: '#fff',
  animation: `${bounce} 1.5s infinite`, // Apply bounce animation
  [theme.breakpoints.down('sm')]: {
    bottom: '20px', // Adjusted position for mobile devices
  },
}));

const FullscreenHero = ({company, jobData}) => {
  // const { jobData } = useContext(PageContext);
  const heroRef = useRef(null); // Ref to capture hero container

  // Function to handle scroll to specific section when "Get Started" button is clicked
  const handleGetStarted = () => {
    const targetSection = document.getElementById('apply'); // Replace 'your-container-id' with the actual ID
    if (targetSection) {
      targetSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Function to handle scroll on arrow click
  const handleScrollDown = () => {
    if (heroRef.current) {
      const heroHeight = heroRef.current.clientHeight; // Get hero height
      const scrollAmount = heroHeight * 0.8; // Calculate 80% of hero height
      window.scrollTo({
        top: window.scrollY + scrollAmount, // Scroll by 80% of the hero height
        behavior: 'smooth', // Smooth scroll
      });
    }
  };

  return (
    <HeroContainer
      ref={heroRef}
     
    >
      <img className='hero__backgroundImage' src={jobData?.backgroundImage} alt="" />

      {/* Dark overlay */}
      <Overlay />
      

      {/* Content */}
      <div className='hero__infoWrapper'>

        <Typography variant="h1" component="h1" gutterBottom sx={{ 
          zIndex: 2, 
          fontSize: {xs: "32px", md: "62px!important"}, 
          maxWidth: {xs: '100%', md: "700px"} 
        }} className='hero___position'>
          {jobData?.title}
        </Typography>

        <Button
              type="submit"
              fullWidth
              variant="contained"
              href='#apply'
              sx={{ 
                mt: { xs: 2, md: 0}, 
                mb: 2, 
                borderRadius: "10px", 
                padding: "12px 25px", 
                fontWeight: "600", 
                width: "fit-content", 
                fontSize: '13px',
                backgroundColor: 'white', 
                color: 'black', 
                transition: 'background-color 500ms, color 500ms',
                '&:hover': {
                  background: config.colors.secondary,
                  color: config.colors.white
                },
                ":disabled": {
                  backgroundColor: "white", 
                  opacity: .7 
              }}}
              >
              Ansök nu {/* Change button text based on loading state */}
        </Button>
      </div>
     
     

      {/* Animated arrow icon to scroll down */}
      <AnimatedIconButton onClick={handleScrollDown}>
        <ArrowDownwardIcon fontSize="large" />
      </AnimatedIconButton>
    </HeroContainer>
  );
};

export default FullscreenHero;
